<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="alerts-details">
    <div class="pagination-info">
        <span class="paginationInfo-Alerttable">
            Showing {{showFrom}} to {{showTo}} of {{totalRecords}} records
        </span>
    </div>
    <div class="alert-details-table">
        <p-table [value]="allAlerts" scrollable="true" [scrollHeight]='scrollHeight' id="alertsDetailsWindow" [responsive]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th class="desk-signoff" pSortableColumn="deskSignOffTs">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertDeskSignOff}}
                        </span>
                        <p-sortIcon field="deskSignOffTs"></p-sortIcon>
                    </th>
                    <th class="director-signoff" pSortableColumn="dirSignOffTs">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertDirSignOff}}
                        </span>
                        <p-sortIcon field="dirSignOffTs"></p-sortIcon>
                    </th>
                    <th *ngIf="(alertLevel && alertLevel === 'SYS') ? true: false" class="desk-column" pSortableColumn="deskId">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertDesk}}
                        </span>
                        <p-sortIcon field="deskId"></p-sortIcon>
                    </th>
                    <th class="loco-column" pSortableColumn="locoId">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertLocomotive}}
                        </span>
                        <p-sortIcon field="locoId"></p-sortIcon>
                    </th>
                    <th class="train-column" pSortableColumn="trainId">
                        <span class="p-column-title">
                        {{configData.alertLabel.alertTrain}}
                        </span>
                        <p-sortIcon field="trainId"></p-sortIcon>
                    </th>
                    <th class="terminal-column" pSortableColumn="terminal">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertTerminal}}
                        </span>
                        <p-sortIcon field="terminal"></p-sortIcon>
                    </th>
                    <th class="desc-column">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertDescription}}
                        </span>
                        <!-- <p-sortIcon field="description"></p-sortIcon> -->
                    </th>
                    <th class="tag-column">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertTag}}
                        </span>
                        <!-- <p-sortIcon field="permTag"></p-sortIcon> -->
                    </th>
                    <th class="created-expire-col" pSortableColumn="createDate">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertCreated}}
                        </span>
                        <p-sortIcon field="createDate"></p-sortIcon>
                    </th>
                    <th class="created-expire-col" pSortableColumn="expiredDate">
                        <span class="p-column-title">
                            {{configData.alertLabel.alertExpired}}
                        </span>
                        <p-sortIcon field="expiredDate"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-alert let-rowIndex="rowIndex">
                <tr>
                    <td class="desk-signoff">
                        <div class='{{(signOffStatus && alert.deskSignOffTs) ? "readonly-check" : ""}} {{alert.background && alert.background === "red" ? "redBackground" : ""}}'>
                            <p-checkbox [(ngModel)]='alert.deskCheckStatus' binary="true" [disabled]='(alertLevel !== "DES" || (alert.deskSignOffTs && alert.deskSignOffTs !== "")) ? true : false' (onChange)='singOffActionDesk(alert, $event);'></p-checkbox>
                        </div>
                    </td>
                    <td class="director-signoff">
                        <div class='{{(signOffStatus && alert.dirSignOffTs) ? "readonly-check" : (alertLevel && alertLevel === "DES" && alert.priority !== "1") ? "readOnly-displayNone" : " "}} {{alert.background && alert.background === "red" ? "redBackground" : ""}}'>
                            <p-checkbox [(ngModel)]='alert.dirCheckStatus' binary="true" [disabled]='(alertLevel === "DES" || (alert.dirSignOffTs && alert.dirSignOffTs !== "")) ? true : false' (onChange)='singOffActionDir(alert, $event);'></p-checkbox>
                        </div>
                    </td>
                    <td *ngIf="(alertLevel && alertLevel === 'SYS') ? true: false" class="desk-column">
                        <div class="{{!(alert?.isAlertRead) ? 'boldText' : ''}}  {{alert.background && alert.background === 'red' ? 'redBackground' : ''}}">
                            {{alert.deskId ? appUtilityService.getDeskNameById(alert.deskId) : '-'}}
                        </div>
                    </td>
                    <td class="loco-column">
                        <a *ngIf='alert.locoId' href="javascript:void(0)" id="locomotive{{alert.locoId}}" class="menu-item-link {{!(alert?.isAlertRead) ? 'boldText' : ''}}  {{alert.background && alert.background === 'red' ? 'redBackground' : ''}}" (click)='routeToPage("Data", "Locomotive", alert.locoId);'
                            (contextmenu)='$event.preventDefault(); setOverlayLinks("loco"); locomotiveOverlayPosition($event, overlayMenuLinks, alert, "loco")'>
                                {{appUtilityService.UIformatLocomotiveId(alert.locoId)}}
                        </a>
                        <span *ngIf='!(alert.locoId)' class="{{alert.background && alert.background === 'red' ? 'redBackground' : ''}}">-</span>
                    </td>
                    <td class="train-column">
                        <a *ngIf='alert.trainId' href="javascript:void(0)" id="train{{alert.trainId}}" class="menu-item-link {{!(alert?.isAlertRead) ? 'boldText' : ''}}  {{alert.background && alert.background === 'red' ? 'redBackground' : ''}}" (click)='routeToPage("Data", "Train", alert.trainId);'
                            (contextmenu)='$event.preventDefault(); setOverlayLinks("train"); locomotiveOverlayPosition($event, overlayMenuLinks, alert, "train")'>
                                {{alert.trainId}}
                        </a>
                        <span *ngIf='!(alert.trainId)' class="{{alert.background && alert.background === 'red' ? 'redBackground' : ''}}">-</span>
                    </td>
                    <td class="terminal-column">
                        <a *ngIf='alert.terminal' href="javascript:void(0)" class="menu-item-link {{!(alert?.isAlertRead) ? 'boldText' : ''}}  {{alert.background && alert.background === 'red' ? 'redBackground' : ''}}" (click)='routeToPage("Status", "Terminal", alert.terminal);'>
                            {{alert.terminal}}
                        </a>
                        <span *ngIf='!(alert.terminal)' class="{{alert.background && alert.background === 'red' ? 'redBackground' : ''}}">-</span>
                    </td>
                    <td class="desc-column">
                        <span class="{{!(alert?.isAlertRead) ? 'boldText' : ''}} {{alert.background && alert.background === 'red' ? 'redBackground' : ''}}">
                            {{alert.description ? alert.description : '-'}} 
                        </span>
                    </td>
                    <td class="tag-column">
                        <span class="{{!(alert?.isAlertRead) ? 'boldText' : ''}} {{alert.background && alert.background === 'red' ? 'redBackground' : ''}}">
                            {{alert.permTag ? alert.permTag : '-'}}
                        </span>
                    </td>
                    <td class="created-expire-col">
                        <span class="{{!(alert?.isAlertRead) ? 'boldText' : ''}} {{alert.background && alert.background === 'red' ? 'redBackground' : 'normalBackground'}}">
                            {{alert.creationTs ? alert.creationTs : '-'}}
                        </span>
                    </td>
                    <td class="created-expire-col">
                        <span class="{{!(alert?.isAlertRead) ? 'boldText' : ''}} {{alert.background && alert.background === 'red' ? 'redBackground' : 'normalBackground'}}">
                            {{alert.expirationTs ? alert.expirationTs : '-'}}
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr class="p-widget-content p-datatable-emptymessage-row">
                    <td colspan="10">
                        No records found
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </div>
</div>
<p-overlayPanel #overlayMenuLinks [dismissable]="true" id='overlayLinksInfo' [ngClass]="'menu-dropdown'">
    <ul>
        <li *ngFor="let link of overlayLinks">
            <a href="javascript:void(0)" (click)='routeToPage(link, contextType, contextSearchText); hideLocoOverlayPanel($event, overlayMenuLinks);'>{{link}}</a>
        </li>
    </ul>
</p-overlayPanel>